import { PostDisplay } from '$types'
import { Component, Input } from '@angular/core'
import { DatePipe } from '@angular/common'

@Component({
  selector: 'app-third-info',
  templateUrl: './third-info.component.html',
  styleUrls: ['./third-info.component.css']
})
export class ThirdInfoComponent {
  constructor(private readonly datepipe: DatePipe){}

  @Input() post!: PostDisplay;

  getFormattedDate(date?: Date) {
    if (!date) { return; }
    return this.datepipe.transform(date, 'dd/MM/YYYY')
  }
}
